module.exports = __webpack_public_path__ + "static/media/gs.aaf64c70.png";